import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-16" }
const _hoisted_2 = {
  role: "list",
  class: "list-none border-l border-transparent"
}
const _hoisted_3 = { class: "relative py-0 my-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "absolute inset-y-0 left-0 w-px bg-zinc-200/10 group-hover:bg-emerald-500" }, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  key: 0,
  class: "bg-orange-500 text-white text-xs ml-2 px-2 py-px rounded-full leading-none opacity-80 group-hover:opacity-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "no-underline",
        to: _ctx.docsRoute(_ctx.DocsRoute.NODES)
      }, {
        default: _withCtx(() => [
          _createTextVNode("Nodes")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]),
      _createElementVNode("span", null, " / " + _toDisplayString(_ctx.context.toUpperCase()), 1 /* TEXT */)
    ]),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodeTypes, (nodeType, i) => {
        return (_openBlock(), _createElementBlock("li", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "group flex justify-between gap-2 py-1 my-0 text-sm pl-4 text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-white no-underline hover:no-underline hover:bg-zinc-800/50",
            to: _ctx.docsNode(_ctx.context, nodeType)
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(nodeType), 1 /* TEXT */),
                (_ctx.examplesCountList[i] > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.examplesCountLabels[i]), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
        ]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}